// please keep this sorted alphabetically
import AnnualGrossIncome from "./annual-gross-income/AnnualGrossIncome";
import Birthdate from "./birthdate/Birthdate";
import BirthdateWithInputFields from "./birthdate-with-inputfields/BirthdateWithInputFields";
import ConfiguredDate from "./configured-date/ConfiguredDate";
import DeviceFingerprint from "./device-fingerprint/DeviceFingerprint";
import Email from "./email/Email";
import EmailWithConfirmation from "./email-with-confirmation/EmailWithConfirmation";
import EmployerName from "./employer-name/EmployerName";
import LoanAmount from "./loan-amount/LoanAmount";
import LoanAmountSelect from "./loan-amount-select/LoanAmountSelect";
import PhoneNumber from "./phone-number/PhoneNumber";
import Recaptcha from "./recaptcha/Recaptcha";
import SocialSecurity from "./social-security/SocialSecurity";
import PaymentAmount from "./payment-amount/PaymentAmount";
// please keep this sorted alphabetically

const components = {
  AnnualGrossIncome,
  Birthdate,
  BirthdateWithInputFields,
  ConfiguredDate,
  DeviceFingerprint,
  Email,
  EmailWithConfirmation,
  EmployerName,
  LoanAmount,
  LoanAmountSelect,
  PaymentAmount,
  PhoneNumber,
  Recaptcha,
  SocialSecurity
};

export default components;
